import { render, staticRenderFns } from "./DxCreateEmployee.vue?vue&type=template&id=598d4c40&scoped=true&"
import script from "./DxCreateEmployee.vue?vue&type=script&lang=js&"
export * from "./DxCreateEmployee.vue?vue&type=script&lang=js&"
import style0 from "./DxCreateEmployee.vue?vue&type=style&index=0&id=598d4c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598d4c40",
  null
  
)

export default component.exports